<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>PART ONE</span></p>
<p class="part-title"><span><i>Perama</i></span></p>
<p class="center"><span><i>Here great trees cool-shaded grow, pear, pomegranate, rich apple, honey-sweet fig and blossoming olive, forever bearing fruit, winter and summer never stripped, but everblowing the western wind brings fruit to birth and ripens others. Pear follows pear, apple after apple grows, fig after fig, and grape yields grape again.</i></span></p>
<p class="center"><span>–H<span class="smallcaps">OMER</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?02a431b8